export const queryKeys = {
  CASHBACK_CONFIG_ALL: 'CASHBACK_CONFIG_ALL',
  CASHBACK_PAYMENT_FILTER: 'CASHBACK_PAYMENT_FILTER',
  CASHBACK_ACTIVE: 'CASHBACK_ACTIVE'
};
